import React, { useState } from "react";
import { Modal, Button, Spin } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { URL } from "../../helper/Mainurl";

const LearnMoreModal = ({
  moduleName,
  triggerText = "Learn More",
  buttonType = "default",
  buttonClass = "",
  children,
}) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("Learn More");
  const openModal = async () => {
    // console.log("openModal:", moduleName);
    setVisible(true);
    setLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${URL}/v1/get-content/${moduleName}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      // console.log("Learn More Data:", data, moduleName);
      if (data.code === 200 && data.data) {
        setTitle(
          data.data.module_name
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase())
        );
        setContent(data.data.learn_more_content);
      } else {
        setContent("<p>Failed to load content.</p>");
      }
    } catch (error) {
      setContent("<p>Failed to load content.</p>");
    }
    setLoading(false);
  };

  const closeModal = () => {
    setVisible(false);
    setContent("");
  };

  return (
    <>
      <Button
        type={buttonType}
        className={buttonClass}
        icon={<InfoCircleOutlined />}
        onClick={openModal}
      >
        {triggerText}
      </Button>
      <Modal
        open={visible}
        onCancel={closeModal}
        footer={null}
        title={title}
        width={600}
        // bodyStyle={{ minHeight: 200 }}
      >
        {loading ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            <Spin size="large" />
          </div>
        ) : (
          <div
            style={{ textAlign: "justify" }}
            className="learn-more-content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
        {children}
      </Modal>
    </>
  );
};

export default LearnMoreModal;
